import {
  GET_CREATE_EVENT_ITEMS_FAILURE,
  GET_CREATE_EVENT_ITEMS_REQUEST,
  GET_CREATE_EVENT_ITEMS_SUCCESS,
} from "../createConstant/GetCreateConsant";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const getCreateEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CREATE_EVENT_ITEMS_REQUEST:
      console.log("Requesting events...");
      return { ...state, loading: true, error: null };
    case GET_CREATE_EVENT_ITEMS_SUCCESS:
      console.log(`Events loaded successfully. Count: ${action.payload.count}, Loaded: ${action.payload.results.length}`);
      return { ...state, loading: false, data: action.payload };
    case GET_CREATE_EVENT_ITEMS_FAILURE:
      console.error("Failed to load events:", action.payload);
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export default getCreateEventReducer;
